import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BlogService {
  private apiUrl = `${environment.baseURL}api/f/blogs`;

  constructor(private http: HttpClient) { }

  getAllBlogs(): Observable<any> {
    return this.http.get(`${this.apiUrl}/allBlogs`);
  }

  getBlog(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/getBlogs/${id}`);
  }

  // ✅ NEW: PUBLIC (SLUG-based)
  getBlogBySlug(slug: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/slug/${slug}`);
  }

  addBlog(blog: any): Observable<any> {
    return this.http.post(this.apiUrl, blog);
  }

  updateBlog(id: string, blog: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, blog);
  }

  deleteBlog(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  addComment(data: any): Observable<any> {
  return this.http.post(
    `${this.apiUrl}/addComment`,
    data
  );
}

getComments(blogId: number): Observable<any> {
  return this.http.get(
    `${this.apiUrl}/comments/${blogId}`
  );
}

}